import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
const benefits = ['Qué escribir después de que te dejan en visto', 'Cómo generar curiosidad para que responda', 'Cómo hacer que piense en ti sin parecer intensa', 'Cómo recuperar conversaciones muertas'];
export function Benefits() {
  return <section className="py-16 px-6 bg-[#0a0a0a] relative overflow-hidden" data-id="element-12">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-rose/50 to-transparent opacity-50" data-id="element-13" />

      <div className="max-w-3xl mx-auto" data-id="element-14">
        <FadeIn data-id="element-15">
          <h2 className="font-serif text-3xl md:text-5xl font-bold mb-10 text-center" data-id="element-16">
            Esto es lo que vas a{' '}
            <span className="text-brand-rose italic" data-id="element-17">aprender:</span>
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-18">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-19">
              <div className="flex items-center gap-4 p-5 rounded-2xl bg-[#161616] border border-white/5 hover:border-brand-rose/20 transition-colors" data-id="element-20">
                <div className="w-8 h-8 rounded-full bg-brand-rose/10 flex items-center justify-center shrink-0" data-id="element-21">
                  <CheckCircle2 className="w-5 h-5 text-brand-rose" data-id="element-22" />
                </div>
                <p className="text-lg text-brand-cream font-medium" data-id="element-23">
                  {benefit}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}